module.exports = __webpack_public_path__ + "static/media/Klang_gaussian2.7029e147.png";